import React from 'react'
import {FaHeartbeat} from 'react-icons/fa'
import BloodPressureIcon from '../../modules/user/components/common/BloodPressureIcon'

interface VerticalReadingProps {
  topValue: string | number
  bottomValue: string | number
  bpmValue?: string | number
  className?: string
}

const VerticalReading: React.FC<VerticalReadingProps> = ({
  topValue,
  bottomValue,
  bpmValue,
  className = '',
}) => {
  return (
    <div className={`d-flex align-items-center ${className}`}>
      {/* Blood Pressure */}
      <div className='d-flex align-items-center'>
        <BloodPressureIcon width={32} height={32} fillColor='#6f42c1' />
        <div className='d-flex flex-column'>
          <span className='m-0 fs-5 text-center'>{topValue}</span>
          <div className='divider' />
          <span className='m-0 fs-5 text-center'>{bottomValue}</span>
        </div>
        {/* &nbsp;<span>mmHg</span> */}
      </div>

      {/* BPM - only render if bpmValue is provided */}
      {bpmValue && (
        <div className='d-flex align-items-center ms-3'>
          <span className='fs-5'>{bpmValue}</span>&nbsp;<span className='me-2'>bpm</span>
          <FaHeartbeat className='text-primary' size={24} />
        </div>
      )}
    </div>
  )
}

export default VerticalReading
